import { combineReducers } from '@ngrx/store';

import { appStateSliceKey } from 'Angular/state/app-state/app-state.reducer';
import { targetRates } from 'TargetRatesApp/apps/target-rates-app/state/target-rates.reducer';

import {
    TARGET_RATES_APP_STATE_SLICE_KEY,
    TARGET_RATES_DEFAULT_STATE,
} from 'TargetRatesApp/apps/target-rates-app/state/constants';

import { createReducerWithAppState } from 'Angular/state/app-state/utils';

const initialSystemState = {
    [TARGET_RATES_APP_STATE_SLICE_KEY]: TARGET_RATES_DEFAULT_STATE,
};

const initialUserState = {
    [TARGET_RATES_APP_STATE_SLICE_KEY]: window.userProvidedAppState,
};

const reducers = combineReducers({ appStateSliceKey, targetRates });

export const rootReducer = createReducerWithAppState(reducers, initialSystemState, initialUserState);
